import { Controller } from "@hotwired/stimulus"

const THROTTLE_MS = 30000

export default class extends Controller {
  connect() {
    this.lastChecked = 0
    this.handlePageShow = this.handlePageShow.bind(this)
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this)
    window.addEventListener("pageshow", this.handlePageShow)
    document.addEventListener("visibilitychange", this.handleVisibilityChange)
  }

  disconnect() {
    window.removeEventListener("pageshow", this.handlePageShow)
    document.removeEventListener("visibilitychange", this.handleVisibilityChange)
  }

  handlePageShow(event) {
    if (event.persisted || this.isBackForwardNavigation()) {
      this.checkSession()
    }
  }

  isBackForwardNavigation() {
    const entries = performance.getEntriesByType("navigation")
    return entries.length > 0 && entries[0].type === "back_forward"
  }

  handleVisibilityChange() {
    if (document.visibilityState === "visible") {
      this.checkSession()
    }
  }

  checkSession() {
    const now = Date.now()
    if (now - this.lastChecked < THROTTLE_MS) return

    this.lastChecked = now
    fetch("/api/v1/session", { credentials: "same-origin" })
      .then(response => {
        if (response.status === 401) {
          window.location.reload()
        }
      })
      .catch(() => {})
  }
}
